import { isBefore, isSameDay, startOfDay } from "date-fns";
import { EVENT_STATUS } from "ui/StatusLabel/constants/eventStatus";

import type { TimeStamp } from "pages/AccountSettlementHistoryOrderId/types/TimeStamp";

type EventStatus = (typeof EVENT_STATUS)[keyof typeof EVENT_STATUS];

type EventPart = {
  name: string;
  openTime: TimeStamp;
};

const getStatus = (sortedParts: EventPart[], today: Date): EventStatus => {
  if (sortedParts.length === 0) return EVENT_STATUS.EVENT_ENDED;

  const hasOnGoingPart = sortedParts.some((part) => {
    const eventDate = startOfDay(new Date(part.openTime.seconds * 1000));
    return isSameDay(today, eventDate);
  });
  if (hasOnGoingPart) return EVENT_STATUS.DURING_EVENT;

  const hasFuturePart = sortedParts.some((part) => {
    const eventDate = startOfDay(new Date(part.openTime.seconds * 1000));
    return isBefore(today, eventDate);
  });
  if (hasFuturePart) return EVENT_STATUS.BEFORE_EVENT;

  return EVENT_STATUS.EVENT_ENDED;
};

export const getTicketStatus = (
  eventParts: EventPart[]
): {
  status: EventStatus;
  firstPartTime: TimeStamp | null;
  lastPartTime: TimeStamp | null;
} => {
  const sortedParts = [...eventParts].sort(
    (a, b) => a.openTime.seconds - b.openTime.seconds
  );

  const [firstPart] = sortedParts;
  const lastPart = sortedParts[sortedParts.length - 1];
  const today = startOfDay(new Date());

  return {
    status: getStatus(eventParts, today),
    firstPartTime: firstPart?.openTime ?? null,
    lastPartTime: lastPart?.openTime ?? null,
  };
};
